export default __webpack_public_path__ + "static/Profile-Mullet-0eecbd8114720bf25d438763fa1d3b6d.png";